<template>
  <div :id="$domain.publitas.id" />
</template>

<script lang="ts" setup>
const { $domain } = useNuxtApp();

interface Props {
  publication: string;
}

const props = withDefaults(defineProps<Props>(), {
  publication: '',
});

const publication = toRef(props, 'publication', '');

useHead({
  script: [
    {
      'src': 'https://view.publitas.com/embed.js',
      'type': 'application/javascript',
      'async': true,
      'data-cfasync': 'false',
      'data-height': 'undefined',
      'data-publication': publication.value,
      'data-publication-aspect-ratio': 'undefined',
      'data-responsive': 'true',
      'data-width': 'undefined',
      'data-wrapper-id': $domain.publitas.id,
      'publitas-embed': true,
    },
  ],
});

useHead({
  script: {
    src: 'https://scripts.publitas.com/plugins/ecom-light/website.js',
    type: 'text/javascript',
  },
});
</script>
